function Forms() {
	this.build(true);
	barbaCallbacks.push(this);
}

Forms.prototype.build = function (firstLoad) {
	this.forms = $('.wpcf7');
	this.forms.each(function (index, elem) {

		// Init cf7 if loaded from barbaJS
		if (!firstLoad) {
			var $form = $(this).find('form');
			wpcf7.initForm($form);
			if (wpcf7.cached) {
				wpcf7.refill($form);
			}
		}

		// When clicking a form submit button :
		$(elem).find('.wpcf7-submit').on('click', function () {
			$(elem).addClass('loading');
		});

		// When the form validation fails or the mail fails to be sent :
		$(elem).on('wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed wpcf7unaccepted', function () {
			$(elem).removeClass('loading');
		});

		// When the mail is successfully sent
		$(elem).on('wpcf7mailsent', function () {
			$(elem).removeClass('loading');
			$(elem).addClass('success');
		});
	});

	// Managing form inputs and labels focus and filled states :
	this.fields = $('.form__field input:not([type="file"]), .form__field--textarea textarea, .form__field--select select');
	this.fields.each(function (index, elem) {
		let $inputContainer = $(elem).closest('.form__container');
		$(elem).on('focus', function () {
			$inputContainer.addClass('active');
		}).on('blur', function () {
			$inputContainer.removeClass('active');

			if ($(elem).val() === "") {
				$inputContainer.removeClass('filled');
			} else {
				$inputContainer.addClass('filled');
			}
		});
	});

	// Managing input files
	this.fileuploads = $('.form__container--file');
	this.fileuploads.each(function (index, elem) {
		let $inputContainer = $(elem),
			$input = $(elem).find('input[type="file"]'),
			$responseContainer = $(elem).find('.form__value'),
			responseValue = $responseContainer.html();

		$responseContainer.on('click', function () {
			$input.trigger('click');
		});
		$input.on('change', function (e) {
			let fileName = e.target.value.split('\\').pop();

			if (fileName) {
				$responseContainer.html(fileName);
				$inputContainer.addClass('filled');
			} else {
				$responseContainer.html(responseValue);
				$inputContainer.removeClass('filled');
			}
		});

		// Firefox bug fix
		$input
			.on('focus', function () {
				$input.addClass('has-focus');
			})
			.on('blur', function () {
				$input.removeClass('has-focus');
			});
	});
};

Forms.prototype.destroy = function () {
	if (this.forms && this.forms.length) {
		this.forms.each(function (index, elem) {
			$(elem).find('.wpcf7-submit').off('click');
			$(elem).off('wpcf7invalid wpcf7spam wpcf7mailsent wpcf7mailfailed wpcf7mailsent wpcf7unaccepted');
		});
	}

	if (this.fields && this.fields.length) {
		this.fields.each(function (index, elem) {
			$(elem).off('focus blur');
		});
	}
};
